
import Vehicle from '@/models/vehicle'
import Vue from 'vue'

Vue.filter('vehicleTitle', (vehicle: Vehicle): string => {
  const brand = vehicle.properties.brand ?? ''
  const model = vehicle.properties.model ?? ''
  const type = vehicle.properties.type ?? ''
  return (brand + ' ' + model + ' ' + type).replace('  ', ' ')
})
